<template>
  <div>
    <v-row>
      <template v-for="item of aboutNews">
        <v-col :key="item.news_id" cols="12" md="6">
          <NewsCard
            :border="parseInt(item) <= 4-2"
            :image="item.image_path"
            :title="item[`title_${lang}`]"
            :description="item[`intro_${lang}`]"
            :date="item[`publish_date_${lang}`] | moment('DD MMM YYYY')"
            :viewer="item.viewer"
            class="cursor-pointer"
            @click.native="newsHandler(item.news_id)"
          />
        </v-col>
      </template>
    </v-row>
    <v-row>
      <v-col>
        <GreenButton label="read more" @click.native="readMoreHandler" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NewsCard from "../cards/NewsCard";
import GreenButton from "../buttons/GreenButton";
import { mapState } from 'vuex';
import {Utils} from "@/util/Utils";

export default {
  components: {
    NewsCard,
    GreenButton
  },
  computed: {
    ...mapState({
      // aboutNews: state => state.About.news.data,
      lang: state => state.Branch.lang,
      aboutNews: state => {
        if (state.About.news.data) {
          return state.About.news.data
        }
      },
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
    })
  },
  methods: {
    newsHandler(id) {
      const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
      this.$router.push(`/${this.lang}`+`${branch}/about/news/${id}`);
    },
    readMoreHandler() {
      const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
      this.$router.push(`/${this.lang}`+`${branch}/about/news`);
    }
  }
};
</script>

<style>
</style>
